<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="项目名称" prop="name"><el-input v-model="formParameter.name"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="项目经理" prop="sm"><el-input v-model="formParameter.sm"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="组员数量" prop="member">
							<el-input v-model="formParameter.member" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="项目周期" prop="period"><el-input v-model="formParameter.period"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="类型" prop="type"><el-input v-model="formParameter.type"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<!-- <el-col :span="24">
							<el-form-item label="用户故事" prop="content"><el-input v-model="formParameter.content" autocomplete="off"></el-input></el-form-item>
						</el-col> -->
					<el-col :span="24">
						<el-form-item label="摘要" prop="summary">
							<el-input type="textarea" :row="2"  v-model="formParameter.summary" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<!-- <el-col :span="24">
							<el-form-item label="用户故事" prop="content"><el-input v-model="formParameter.content" autocomplete="off"></el-input></el-form-item>
						</el-col> -->
					<el-col :span="24">
						<el-form-item label="用户故事" prop="content">
							<wang-edit ref="ss" v-model="formParameter.content"
								autocomplete="off"></wang-edit>
						</el-form-item>
					</el-col>
				</el-row>


			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确
				定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/online/onlineprojects/onlineprojects.js';
import wangEdit from '@/components/wangEdit/wangEdit.vue';
export default {
	name: 'edit',
	components: {
		popup,
		wangEdit
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			dynamicTags: [],
			inputVisible: false,
			inputValue: '',
			rules: {
				//名称
				name: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],
				//项目经理
				sm: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],

				//周期
				period: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],
				//类型:管理类，电商类,,,
				type: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 255,
						trigger: 'blur'
					}
				],
				//用户故事
				content: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],
				summary: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],

			}
		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				if (!this.parameter.id) {
					//添加
					let parameter = this.$utils.merger(this.formParameter);
					api.save(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameter = this.$utils.merger(this.formParameter);
					api.update(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();
			//清空标签内容
			this.dynamicTags = [];
			//清空富文本内容
			this.$refs.ss.init();



			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {
					this.formParameter = response.data;
					this.formParameter.content = this.$refs.ss.init(this.formParameter.content);
					this.popupLoading = false;
				});
			} else {
				//添加
				this.popupLoading = false;
			}
		},
	 

		showInput() {
			this.inputVisible = true;
			this.$nextTick(_ => {
				this.$refs.saveTagInput.$refs.input.focus();
			});
		} 
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
